// extracted by mini-css-extract-plugin
export default {"container":"logo_container__oEcuE","logo_bg":"logo_logo_bg__Q7EWR","logo_letter":"logo_logo_letter__YYAz3"};